export default __webpack_public_path__ + "static/media/quick_start.8ed602f8.svg";